import AnalyteResultModel from "@/models/lab/AnalyteResultModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

/**
 * AnalyteResult collection
 */
export default class AnalyteResultCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return AnalyteResultModel;
  }

}
